import React, { Component, PropTypes } from 'react';

import Description from './company-description';
import Contacts from './company-contact';
import LocationOrProduct from './location-or-product-list/company-location';
import Icon from '../tc-ui/icon';
import Amenities from './amenities';
import ProductInfo from './product-info';
import CompanyNotes from './company-notes';
import R, { path, call, ifElse, always, equals, propOr, contains, intersection } from 'ramda';
import MarketingMaterials from '../marketing-materials/container';
import Memberships from './memberships/memberships-container';
import { deleteOrganizationInProfile } from '../../stores/profile/memberships/actions';

class Content extends Component {
  constructor(props) {
    super(props);
  }

  getBreadcrumb = () => {
    const { profileToShow, routeName, user, isViewingOwnProfile } = this.props;
    const isOneLocationSupplier = path(['company', 'oneOrMultiProperties'], user) === 'one-prop';
    const breadcrumbs = (() => {
      if (routeName === 'location') {
        return (
          <div>
            {isOneLocationSupplier ? '' :
              <div>
                <div onClick={this.transitionBack.bind(this, 'profile')} className="breadcrumb breadcrumb-link">
                  {profileToShow.companyName}
                </div>
                <Icon className="tc-icon-chevron-right" />
                <div className="breadcrumb">{profileToShow.locationName}</div>
              </div>}
          </div>
        );
      } else if (routeName === 'product') {
        const location = (() => {
          return (
            <span>
              <div onClick={this.transitionBack.bind(this, 'location')} className="breadcrumb breadcrumb-link">
                {profileToShow.locationName}
              </div>
              <Icon className="tc-icon-chevron-right" />
            </span>
          );
        })();
        return (
          <div>
            <div
              onClick={isViewingOwnProfile ? this.transitionBack.bind(this, 'location') : this.transitionBack.bind(this, 'profile')}
              className="breadcrumb breadcrumb-link"
            >
              {profileToShow.companyName}
            </div>
            <Icon className="tc-icon-chevron-right" />
            {isOneLocationSupplier ? '' : location}
            <div className="breadcrumb">{profileToShow.productName}</div>
          </div>
        );
      }
    })();

    return (
      <div className="breadcrumb-container">
        {breadcrumbs}
      </div>
    );
  };

  getAmenities = () => {
    const { routeName, profileToShow, isEditable, user } = this.props;
    const isOneLocationSupplier = path(['company', 'oneOrMultiProperties'], user) === 'one-prop';
    if (((['product', 'location'].indexOf(routeName) > -1) || (routeName === 'profile' && isOneLocationSupplier)) &&
      isEditable &&
      profileToShow.productType === 'accommodation' ||
      profileToShow.amenities &&
      profileToShow.amenities.length) {
      return <Amenities { ...this.props } amenities={profileToShow.amenities || []} />;
    }
  };

  getContactsNode = () => {
    const { profileToShow, isEditable, routeName, isViewingOwnProfile } = this.props;
    const contacts = profileToShow.contacts;
    if (contacts && contacts.length || isEditable && routeName !== 'product') {
      return (
        <Contacts
          contacts={contacts}
          isViewingOwnProfile={isViewingOwnProfile}
          className="contact-sale"
          { ...this.props }
        />
      );
    }
  };

  getLocationsOrProductsCard = () => {
    const { routeName, profileToShow, isEditable, user } = this.props;
    const isOneLocationSupplier = path(['company', 'oneOrMultiProperties'], user) === 'one-prop';
    const locationsOrProducts = profileToShow.locations || profileToShow.products;
    if (profileToShow.type !== 'Contractor' && routeName !== 'product' && isEditable === true ||
      locationsOrProducts && locationsOrProducts.length) {
      return (
        <LocationOrProduct
          { ...this.props }
          groups={profileToShow.groups}
          locations={profileToShow.locations}
          products={profileToShow.products}
          isOneLocationSupplier={isOneLocationSupplier}
          singleLocId={user.company.singleLocId}
          className="location-data"
        />
      );
    }
  };

  getProductInfo = () => {
    const { routeName, profileToShow, isEditable } = this.props;
    if ((routeName === 'profile-product' || routeName === 'product') && profileToShow.type === 'nonAccommodation') {
      if ((typeof profileToShow.productInfo === 'object' && Object.keys(profileToShow.productInfo).length) || isEditable) {
        return (
          <ProductInfo
            className="product-info"
            productInfo={profileToShow.productInfo}
            { ...this.props }
          />
        );
      }
    }
  };

  getMembershipInfo = () => {
    const { dispatch, user, isEditable, routeName } = this.props;
    if (routeName === 'profile' && isEditable) {
      return (
        <Memberships
          dispatch={dispatch}
          user={user}
          isEditable={isEditable}
          deleteOneOrganization={(organization) => dispatch(deleteOrganizationInProfile(organization))}
        />
      );
    }
  };

  getMarketingMaterials = () => {
    const { isEditable, routeName, user, params, MMReducer } = this.props;
    const isOneLocationSupplier = path(['company', 'oneOrMultiProperties'], user) === 'one-prop';
    const tagIDToFind = call(ifElse(
      equals(true),
        () => call(ifElse(
          equals(true),
            always(params.locationId),
          always(params.productId)
        ), Boolean(params.locationId)),
      always(undefined)
    ), routeName !== 'profile');
    // find additional tags related to products of the same location
    const additionalTags = (MMReducer.locations || [])
    .filter(e => (e.id === tagIDToFind))
    .reduce((prev, current) => [...prev, ...current.products.map(p => p.id)], []);
    // filter media using the search tag + additionalTags
    const findPhotosForTag = tagIDToFind ? (MMReducer.media || []).filter(obj => {
      if (intersection([tagIDToFind, ...additionalTags], (obj.tags || [])).length > 0) return obj;
    }) : [];
    return (
      <MarketingMaterials
        isEditable={isEditable}
        isSupplier
        routeName={routeName}
        isOneLocationSupplier={isOneLocationSupplier}
        findPhotosForTag={findPhotosForTag}
        forLocationOrProductPages={routeName !== 'profile'}
        params={params}
      />
    );
  }

  transitionBack = route => {
    const { profileToShow, history, isEditable, location } = this.props;
    const url = (() => {
      if (route === 'profile') {
        if (isEditable || R.contains('profile', location.pathname.split('/'))) return '/profile';
        return `/company/${profileToShow.companyId}`;
      }
      if (isEditable && route === 'location' || route === 'location' && R.contains('profile', location.pathname.split('/'))) return `/profile/locations/${profileToShow.locationId}`;
      if (route === 'location') return `/locations/${profileToShow.locationId}`;
    })();
    history.push(url);
    // window.location.reload();
  };

  render() {
    const { user } = this.props;
    const isOneLocationSupplier = path(['company', 'oneOrMultiProperties'], user) === 'one-prop';

    return (
      <div>
        <div id="breadcrumb-div">{this.getBreadcrumb()}</div>
        <div id="description-div"><Description { ...this.props } className="description-data" /></div>
        <div id="amenities-div">{this.getAmenities()}</div>
        <div id="productinfo-div">{this.getProductInfo()}</div>
        <div id="locations-products-div">{this.getLocationsOrProductsCard()}</div>
        <div id="memebership-div">{this.getMembershipInfo()}</div>
        <div id="mm-div">{this.getMarketingMaterials()}</div>
        <div id="contacts-div">{this.getContactsNode()}</div>
        {isOneLocationSupplier ? <div id="notes-div"><CompanyNotes {...this.props } /></div> : undefined}
      </div>
    );
  }
}

Content.propTypes = {
  profileToShow: PropTypes.object,
  history: PropTypes.object,
  isEditable: PropTypes.bool,
  routeName: PropTypes.string,
  isViewingOwnProfile: PropTypes.bool,
  user: PropTypes.object,
  dispatch: PropTypes.func,
  MMReducer: PropTypes.object,
  params: PropTypes.object,
  profileLocation: PropTypes.object,
  location: PropTypes.object,
};

export default Content;



// WEBPACK FOOTER //
// ./src/app/components/profile/content.jsx